import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { TeamsPageRoutingModule } from './teams-routing.module';
import { FontAwesomeModule, FaIconLibrary } from '@fortawesome/angular-fontawesome';

import { TeamsPage } from './teams.page';
import { CreateTeamComponentModule } from '../../components/create-team/create-team.module';
import { EditCompanyComponentModule } from 'src/app/components/edit-company/edit-company.module';
import { CreateUserComponentModule } from '../../components/create-user/create-user.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    FontAwesomeModule,
    CreateTeamComponentModule,
    EditCompanyComponentModule,
    CreateUserComponentModule,
    TeamsPageRoutingModule
  ],
  declarations: [TeamsPage]
})
export class TeamsPageModule {}
